import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  IconButton,
  Typography,
  Box
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Form, Field } from 'react-final-form';

// Replace this with your actual logo path
import appLogo from "../../assets/logo_200.png" 
//appLogo = "../../assets/logo_200.png"; // Example for Create React App

const validate = values => {
  const errors = {};
  if (!values.email) {
    errors.email = 'Required';
  } else if (!/\S+@\S+\.\S+/.test(values.email)) {
    errors.email = 'Invalid email address';
  }

  if (!values.password) {
    errors.password = 'Required';
  }

  return errors;
};

const LoginDialog = ({ open, onClose, onSubmit }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: '#fff',
          boxShadow: 8,
          borderRadius: 2
        }
      }}
      BackdropProps={{
        sx: {
          backgroundColor: '#ffffff',
          opacity: 1
        }
      }}
    >
      <DialogTitle sx={{ p: 0 }}>
        <Box
          sx={{
            textAlign: 'center',
            py: 3,
            px: 2,
            borderBottom: '1px solid #eee',
            position: 'relative'
          }}
        >
          {/* <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500]
            }}
          >
            <CloseIcon />
          </IconButton> */}
          <Box component="img" src={appLogo} alt="App Logo" sx={{ height: 48, mb: 1 }} />
          <Typography variant="h6" fontWeight="bold">
          Access Credentials
          </Typography>
        </Box>
      </DialogTitle>

      <Form
        onSubmit={onSubmit}
        validate={validate}
        render={({ handleSubmit, submitting, pristine }) => (
          <form onSubmit={handleSubmit} noValidate>
            <DialogContent dividers>
              <Field name="email">
                {({ input, meta }) => (
                  <TextField
                    {...input}
                    type="email"
                    label="Email"
                    fullWidth
                    margin="normal"
                    error={meta.touched && Boolean(meta.error)} 
                    helperText={meta.touched && meta.error}
                  />
                )}
              </Field>
              <Field name="password">
                {({ input, meta }) => (
                  <TextField
                    {...input}
                    type="password"
                    label="Password"
                    fullWidth
                    margin="normal"
                    error={meta.touched && Boolean(meta.error)} 
                    helperText={meta.touched && meta.error}
                  />
                )}
              </Field>
            </DialogContent>
            <DialogActions sx={{ px: 3, py: 2 }}>
              {/* <Button onClick={onClose} disabled={submitting}>
                Cancel
              </Button> */}
              <Button
                type="submit"
                variant="contained"
                disabled={submitting || pristine}
              >
                Login
              </Button>
            </DialogActions>
          </form>
        )}
      />
    </Dialog>
  );
};

export default LoginDialog;
